import type { IconSvgObject } from './types';

const ZodiacGeminiIcon: IconSvgObject = [
  ["path", { d: "M4 3C6.15142 4.87032 8.94579 6 12 6C15.0542 6 17.8486 4.87032 20 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 21C17.8486 19.1297 15.0542 18 12 18C8.94579 18 6.15142 19.1297 4 21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 6V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M9 5.99982V17.9998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ZodiacGeminiIcon;
